import {Action, ActionReducer, createReducer, on} from "@ngrx/store";
import {SavedReportsState} from "./savedReports";
import * as savedReports from "./savedReports.actions";
import {SavedReportComponentObject} from '../../classes/saved-report-component-object';
import {TypedAction} from '@ngrx/store/src/models';
import {Serializer} from '../../interfaces/serializer';
import {SavedReport} from '../../interfaces/saved-reports';

const reducer: ActionReducer<SavedReportsState> = createReducer(
  {
    serialized: [],
    componentObjects: [],
    included: [],
    favoriteReports: [],
    loading: false,
    loaded: false,
    initialized: false
  },
  on(savedReports.loadSavedReports, (state: SavedReportsState): SavedReportsState => {
    return {
      ...state,
      loading: true,
      loaded: false,
      initialized: false
    };
  }),
  on(savedReports.loadSavedReportsSuccess, (state: SavedReportsState, action): SavedReportsState => {
    return {
      ...state,
      serialized: action.savedReports,
      componentObjects: action.savedReports.map((report: Serializer<SavedReport>): SavedReportComponentObject => new SavedReportComponentObject(report)),
      included: action.included,
      loading: false,
      loaded: true
    };
  }),
  on(savedReports.createSavedReportsSuccess, (state: SavedReportsState, action): SavedReportsState => {
    return {
      ...state,
      serialized: [ ...state.serialized, action.report ],
      componentObjects: [ ...state.componentObjects, new SavedReportComponentObject(action.report) ]
    };
  }),
  on(savedReports.createSavedReportsStandaloneSuccess, (state: SavedReportsState, action): SavedReportsState => {
    return {
      ...state,
      serialized: [ ...state.serialized, action.report ],
      componentObjects: [ ...state.componentObjects, new SavedReportComponentObject(action.report) ]
    };
  }),
  on(savedReports.updateSavedReportsSuccess, (state: SavedReportsState, action): SavedReportsState => {
    state.componentObjects.find(report => report.payload.id === action.report.id).update(action.report);

    return {
      ...state,
      serialized: state.serialized.map(report => report.id === action.report.id && action.report || report)
    };
  }),
  on(savedReports.updateSavedReportsStandalone, (state: SavedReportsState, action): SavedReportsState => {
    state.componentObjects.find((report: SavedReportComponentObject): boolean => report.payload.id === action.report.id).loading();

    return {
      ...state,
      initialized: false
    };
  }),
  on(savedReports.updateSavedReportsStandaloneSuccess,(state: SavedReportsState, action): SavedReportsState => {
    state.componentObjects.find(report => report.payload.id === action.report.id).update(action.report);

    return {
      ...state,
      serialized: state.serialized.map(report => report.id === action.report.id && action.report || report)
    };
  }),
  on(savedReports.deleteSavedReportsSuccess, (state: SavedReportsState, action): SavedReportsState => {
    return {
      ...state,
      serialized: state.serialized.filter(report => report.id !== action.report.id),
      componentObjects: state.componentObjects.filter(report => report.payload.id !== action.report.id)
    };
  }),
  on(savedReports.favoriteSavedReport, (state: SavedReportsState, action: TypedAction<string> & { report: Serializer<SavedReport> }): SavedReportsState => {
    state.componentObjects.find((report: SavedReportComponentObject): boolean => report.payload.id === action.report.id).loading();

    return {
      ...state,
      initialized: false
    };
  }),
  on(savedReports.favoriteSavedReportSuccess, (state: SavedReportsState, action: TypedAction<string> & { report: Serializer<SavedReport> }): SavedReportsState => {
    state.componentObjects.find((report: SavedReportComponentObject): boolean => report.payload.id === action.report.id).update(action.report);

    return {
      ...state,
      serialized: state.serialized.map((report: Serializer<SavedReport>): Serializer<SavedReport> => report.id === action.report.id && action.report || report),
      initialized: true
    };
  }),
  on(savedReports.initializeSavedReports, (state: SavedReportsState): SavedReportsState => {
    return {
      ...state,
      initialized: false
    };
  }),
  on(savedReports.initializeSavedReportsSuccess, (state: SavedReportsState): SavedReportsState => {
    return {
      ...state,
      initialized: true
    };
  })
);

export const savedReportsReducer: ActionReducer<SavedReportsState> = (state: SavedReportsState, action: Action) => {
  return reducer(state, action);
};
